import type { ReactNode } from "react";

type Props = {
  description: ReactNode;
  title: string;
};

export default function SectionHeader({ description, title }: Props) {
  return (
    <div className="text-center">
      <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{title}</h2>
      <p className="mx-auto mt-4 max-w-3xl text-lg text-gray-600">{description}</p>
    </div>
  );
}
